import axios from 'axios';
import { getAuthHeader, getUserId } from './authService';
import CONFIG, { getApiUrl } from '../utils/config';

// Interface cho dữ liệu phản hồi từ API chatbot
export interface ChatbotResponse {
  response: string;
}

/**
 * Gửi tin nhắn đến API chatbot và nhận phản hồi
 * @param message Tin nhắn người dùng gửi đến bot
 * @returns Phản hồi từ chatbot
 */
export const sendMessageToChatbot = async (message: string): Promise<string> => {
  try {
    const userId = getUserId();
    
    console.log('ChatbotService: UserId', userId);
    
    if (!userId) {
      return "Vui lòng đăng nhập để sử dụng tính năng chat.";
    }
    
    console.log('ChatbotService: Sending message to API', message);
    
    // Sử dụng localhost API thay thế cho URL bên ngoài
    const apiUrl = getApiUrl('/api/chatbot/chat');
    console.log('ChatbotService: API URL', apiUrl);
    
    // Lấy header xác thực
    const authHeader = getAuthHeader();
    
    // Tạo object headers cơ bản
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    
    // Thêm auth header nếu có
    if (authHeader && typeof authHeader === 'object') {
      Object.keys(authHeader).forEach(key => {
        headers[key] = authHeader[key];
      });
    }
    
    const response = await axios.post<ChatbotResponse>(
      apiUrl, 
      { 
        message,
        sessionId: userId
      },
      { headers }
    );
    
    console.log('ChatbotService: Response', response.data);
    
    // Trích xuất phản hồi từ định dạng mới
    if (response.data && response.data.response) {
      return response.data.response;
    } else {
      return "Không nhận được phản hồi hợp lệ từ server.";
    }
  } catch (error) {
    console.error('Lỗi khi gọi API chatbot:', error);
    return "Không thể kết nối đến server. Vui lòng thử lại sau.";
  }
};

